/**
 * @file Defines the form inputs for the create-personal-access-token modal.
 */
import React from "react";

import InputExtra from "@components/Form/InputExtra";
import { TYPE_NONE } from "@components/Form";

const EXTRA_NAME = "A label that identifies where this token is used.";
const EXTRA_AUDIENCES = "Services this token may call. Leave empty to allow all of them.";
const EXTRA_EXPIRES_AT = "Defaults to 90 days from now when left empty.";

type CreateInput = {
  name: "name" | "audiences" | "expiresAt";
  type?: typeof TYPE_NONE;
  itemProps: {
    extra: JSX.Element;
  };
};

/**
 * Builds the name, audiences and expiry inputs for the create-token form.
 */
const getCreateInputs = (): CreateInput[] => {
  return [
    {
      name: "name",
      itemProps: {
        extra: <InputExtra text={EXTRA_NAME} />,
      },
    },
    {
      name: "audiences",
      type: TYPE_NONE,
      itemProps: {
        extra: <InputExtra text={EXTRA_AUDIENCES} />,
      },
    },
    {
      name: "expiresAt",
      type: TYPE_NONE,
      itemProps: {
        extra: <InputExtra text={EXTRA_EXPIRES_AT} />,
      },
    },
  ];
};

export default getCreateInputs;
